import { render, staticRenderFns } from "./OfferDocumentTemplateModal.vue?vue&type=template&id=5192ade5&"
import script from "./OfferDocumentTemplateModal.vue?vue&type=script&lang=js&"
export * from "./OfferDocumentTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5192ade5')) {
      api.createRecord('5192ade5', component.options)
    } else {
      api.reload('5192ade5', component.options)
    }
    module.hot.accept("./OfferDocumentTemplateModal.vue?vue&type=template&id=5192ade5&", function () {
      api.rerender('5192ade5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/OfferDocumentTemplateModal.vue"
export default component.exports